import classNames from 'classnames';
import { getSlug } from '@lib/utils';

import PropertyImages from '@components/property-images';
import Video from '@components/video';
import Map from '@components/map';
import TabSlider from '@components/tab-slider';
import { useListingContext } from '../../context';

import {
  featured_section,
  featured_section_multiple_photos,
  featured_section_singular_photo,
  featured_section_video,
  tabs,
  is_mobile
} from './styles.module.scss';

const PropertyGallery = ({ selectedArea, setSelectedArea, isMedium }) => {
  const {
    photos,
    videoUrl,
    canonicalUrl,
    sharingServicesCollection,
    virtualTourUrl,
    isIdxListing,
    alertPills,
    listingId: id,
    longitude,
    latitude,
    similarProperties,
    propertyTypeId,
    address
  } = useListingContext();

  const showMap = !!longitude && !!latitude && latitude !== 0 && longitude !== 0;

  const tabItems = [
    (videoUrl || showMap) && {
      icon: {
        name: 'photos',
        type: 'filters'
      },
      label: 'Photos'
    },
    videoUrl && {
      icon: {
        name: 'video',
        type: 'filters'
      },
      label: 'Video Tour'
    },
    showMap && {
      icon: {
        name: 'location',
        type: 'filters'
      },
      label: 'Map'
    }
  ].filter((item) => item);

  return (
    <>
      <div
        className={`${
          photos.length <= 1 && !isMedium && selectedArea === 'Photos'
            ? classNames(featured_section, featured_section_singular_photo)
            : selectedArea === 'Video Tour' || selectedArea === 'Map'
              ? classNames(featured_section, featured_section_video)
              : classNames(featured_section, featured_section_multiple_photos)
        } `}
      >
        {photos && selectedArea === 'Photos' && (
          <PropertyImages
            canonicalUrl={canonicalUrl}
            sharingServicesCollection={sharingServicesCollection}
            virtualTourUrl={virtualTourUrl}
            pageHasChat={isIdxListing}
            property={{
              address: address,
              alertPills: alertPills,
              images: photos.map((photo) => {
                return {
                  height: photo.extraLargeImageHeight,
                  title: photo.title,
                  url: photo.extraLargeImageUrl,
                  width: photo.extraLargeImageWidth
                };
              }),
              listingId: id,
              listingUrl: canonicalUrl ? getSlug(canonicalUrl) : `/listing/${id}`
            }}
          />
        )}
        {selectedArea === 'Video Tour' && <Video title={address} url={videoUrl} />}
        {showMap && selectedArea === 'Map' && (
          <Map
            longitude={longitude}
            latitude={latitude}
            address={address}
            similarProperties={similarProperties}
            propertyTypeId={propertyTypeId}
            listingId={id}
          />
        )}
      </div>
      <div className={classNames(is_mobile, tabs)}>
        <TabSlider items={tabItems} setSelectedTabCallback={setSelectedArea} />
      </div>
    </>
  );
};

export default PropertyGallery;
